module.exports = new __parcel__URL__("leaderboard_pvp_button_inactive.b55d0516.png").toString();